import { render, staticRenderFns } from "./scene1animation.vue?vue&type=template&id=256f6ba1&scoped=true&"
import script from "./scene1animation.vue?vue&type=script&lang=js&"
export * from "./scene1animation.vue?vue&type=script&lang=js&"
import style0 from "./scene1animation.vue?vue&type=style&index=0&id=256f6ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f6ba1",
  null
  
)

export default component.exports